var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFranceFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_750)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44_750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15.2207 2.89084H95.7793V76.8917H-15.2207V2.89084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.2207 2.89084H21.7785V76.8917H-15.2207V2.89084Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7803 2.89117H95.7795V76.8921H58.7803V2.89117Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -14.7207,
    y: 3.3916,
    width: 110,
    height: 73,
    stroke: "#C4C4C4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "white",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_750"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44_750"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.2207,
    y: 2.8916,
    width: 111,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranceFlag);
export default __webpack_public_path__ + "static/media/france-flag.9f5858d3664ea844ec342de97eec65ea.svg";
export { ForwardRef as ReactComponent };